import { media, styled } from '@pulse-web-ui/theme';

export const CompaniesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CompanyItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CompanyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DatesGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;

  ${media.desktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Separator = styled.hr`
  width: 100%;
  height: 1px;
  margin: 0;
  border: 0;
  background-color: ${({ theme }) => theme.colors.neutral[30]};
`;
